import { z } from 'zod';

import { paginationSchema } from './pagination';
import { skillShortSchema } from './skill';
import { userSchema } from './user';

const featuredLearningOpportunityUser = userSchema
    .extend({
        featuredAt: z.string(),
        userSkills: skillShortSchema.array(),
    })
    .transform((data) => {
        const { userSkills, ...rest } = data;

        return {
            ...rest,
            skills: userSkills,
        };
    });

export type FeaturedLearningOpportunityUser = z.infer<typeof featuredLearningOpportunityUser>;

export const featuredLearningOpportunityUsersResponseSchema = z.object({
    data: featuredLearningOpportunityUser.array(),
    pagination: paginationSchema,
});

export type FeaturedLearningOpportunityUsersResponse = z.infer<typeof featuredLearningOpportunityUsersResponseSchema>;

export const featuredOpportunityOptionsSchema = z.object({
    canManageFeaturedLearningOpportunities: z.boolean(),
});

export type FeaturedOpportunityOptions = z.infer<typeof featuredOpportunityOptionsSchema>;

export const userFeaturedLearningOpportunityOptionsSchema = z.object({
    canReadUserFeaturedOpportunities: z.boolean(),
});
export type UserFeaturedLearningOpportunityOptions = z.infer<typeof userFeaturedLearningOpportunityOptionsSchema>;
